import { Injectable, Type } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalComponentSource = new BehaviorSubject<Type<any> | null>(null);
  modalComponent = this.modalComponentSource.asObservable();

  openModal(component: Type<any>) {
    this.modalComponentSource.next(component);
  }

  closeModal() {
    this.modalComponentSource.next(null);
  }
}
